import clsx from "clsx";
import { Form, Formik } from "formik";
import { Box, Button, Grid, Typography } from "mui";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "utils/hooks/storeHooks";
import AppCard from "components/AppCard/AppCard";
import styles from "modules/Home/views/ProvidersView/ProvidersView.module.scss";
import { selectSessionCredentials } from "store/session/selectors";
import { selectProviders } from "store/providers/selectors";
import { fetchAllProviders } from "store/providers/thunks";
import { setProvidersCards, setProvidersCollection } from "store/providers";
import { cardType } from "types/Provider";
import variables from "../../../../styles/partials/_variables.module.scss";

interface FormValues {
  cardId?: number;
}
const ProvidersView: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const credentials = useAppSelector(selectSessionCredentials);
  const { user } = credentials;
  const providers = useAppSelector(selectProviders);
  const [cardIdSelected, setCardIdSelected] = useState<number>();
  const newCardsOrderById = [1, 4, 3, 2]; // new order : physician, taxonomy, location, contract
  let reorderedProviders: cardType[] = [];

  // Fetching the list of providers
  useEffect(() => {
    dispatch(fetchAllProviders());
    dispatch(setProvidersCards([]));
    dispatch(setProvidersCollection([]));
  }, []);
  const initialValues: FormValues = {
    cardId: cardIdSelected,
  };

  const handleOnClickCard = (
    cardId: number,
    setFieldValue: (field: string, value: number) => void
  ) => {
    setCardIdSelected(cardId);
    setFieldValue("cardId", cardId);
  };

  const handleGoNext = () => {
    navigate(`/Providers/${cardIdSelected}`);
  };

  newCardsOrderById.forEach((i) => {
    providers.find((provider: cardType) => {
      if (provider?.id === i) reorderedProviders.push(provider);
    });
  });

  return (
    <Box className={styles.background}>
      <Box className={styles.pageContainer}>
        <Box className={styles.pageInfo}>
          <Typography
            justifyContent="center"
            display="flex"
            variant="body1"
            color={variables.mainBlue}
          >{`Hello ${user.name.split(" ", 1)},`}</Typography>
          <Typography className={styles.pageDescription} variant="h2">
            Let's start with your provider network!
          </Typography>
        </Box>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleGoNext}
        >
          {({ setFieldValue }) => (
            <Form>
              <Box
                className={clsx(
                  styles.pageContent,
                  providers.length % 2 === 0 ? "" : styles.pageContentOdd
                )}
              >
                <Grid
                  className={styles.providersContainer}
                  container
                  spacing={3}
                >
                  {reorderedProviders.map(
                    (
                      { id, iconName, title, description }: cardType,
                      index: number
                    ) => (
                      <Button
                        className={styles.buttonsContained}
                        type={title === "By Contract" ? "button" : "submit"}
                        key={index}
                      >
                        <AppCard
                          description={description}
                          iconName={iconName}
                          id={id}
                          // The isSelected can be commented temporarily if needed (if not it changes the style of "by contract" btn which is temporarily not of submit type)
                          isSelected={cardIdSelected === id}
                          title={title}
                          onClick={(id) => handleOnClickCard(id, setFieldValue)}
                        />
                      </Button>
                    )
                  )}
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default ProvidersView;
